import styled from 'styled-components';

export const Container = styled.div`
  background-color: white;
  box-sizing: content-box;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
`;
